import { render, staticRenderFns } from "./Productsbodytwo.vue?vue&type=template&id=086ba489&"
import script from "./Productsbodytwo.vue?vue&type=script&lang=js&"
export * from "./Productsbodytwo.vue?vue&type=script&lang=js&"
import style0 from "./Productsbodytwo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports